enum SourceTypes {
  Search = 'search',
  Recommendation = 'recommendation',
}

export default SourceTypes;
